import React from "react";

// Place your logo strip image at the root of the `public` folder as
// `trustedpartners.png` (i.e. `public/trustedpartners.png`), so it's
// served at "/trustedpartners.png".
const LOGO_STRIP_SRC = "/trustedpartners.png";

const TrustedOrganizations = () => {
  return (
    <div className="ttrust-wrapper">
      <div className="ttrust-card">
        <h2 className="ttrust-heading">Trusted by the following organizations.</h2>
        <p className="ttrust-subtext">
          OceSha AI was created by the team that created technologies for the following organizations.
        </p>
        <div className="ttrust-divider" />

        <div className="ttrust-logo-strip-wrap">
          <img
            className="ttrust-logo-strip"
            src={LOGO_STRIP_SRC}
            alt="Trusted by Oracle, HP, Avery Dennison, American Red Cross, Corning, Honda, Capital Group, NV Energy, and RH"
          />
        </div>
      </div>

      <style>{`
        .ttrust-wrapper, .ttrust-wrapper *{
          box-sizing:border-box;
        }
        .ttrust-wrapper{
          width:100%;
        }
        .ttrust-card{
          width:100%;
          background:#ffffff;
          border-radius:24px;
          border:1px solid #e3ecfb;
          box-shadow:0 24px 60px rgba(70,110,220,.12);
          padding:40px 48px 0 48px;
          overflow:hidden;
          position:relative;
        }
        .ttrust-card::after{
          content:"";
          position:absolute;
          left:0;
          right:0;
          bottom:0;
          height:48px;
          background:linear-gradient(180deg, rgba(120,160,255,0) 0%, rgba(120,160,255,.18) 100%);
          pointer-events:none;
        }
        .ttrust-heading{
          margin:0 0 10px 0;
          font-size:26px;
          line-height:1.3;
          font-weight:700;
          color:#071044;
        }
        .ttrust-subtext{
          margin:0 0 26px 0;
          font-size:15px;
          line-height:1.5;
          color:#5b6785;
          max-width:680px;
        }
        .ttrust-divider{
          height:1px;
          background:#e6eaf3;
          margin-bottom:34px;
        }
        .ttrust-logo-strip-wrap{
          padding-bottom:42px;
          position:relative;
        }
        .ttrust-logo-strip{
          width:100%;
          height:auto;
          display:block;
        }

        @media (max-width: 900px){
          .ttrust-card{ padding:32px 24px 0 24px; }
          .ttrust-heading{ font-size:22px; }
        }
      `}</style>
    </div>
  );
};

export default TrustedOrganizations;